import React from 'react';
import PropTypes from 'prop-types';

const PaginationButton = ({ direction, paging, onPageChange }) => {
	const isNext = direction === 'next';
	const currentPage = Math.floor(paging.pageStart / paging.pageSize) + 1;

	const newStart = isNext
		? paging.pageStart + paging.pageSize
		: paging.pageStart - paging.pageSize;

	const isDisabled = isNext
		? newStart >= paging.totalCount
		: paging.pageStart <= 0;

	const targetPage = isNext ? currentPage + 1 : currentPage - 1;

	const handleClick = (e) => {
		e.preventDefault();
		if (!isDisabled && onPageChange) {
			onPageChange(newStart);
		}
	};

	const href = isDisabled
		? '#'
		: `${window.location.pathname}?start=${newStart}`;

	const iconClass = isNext
		? 'ddc-icon ddc-icon-skinny-arrow-right'
		: 'ddc-icon ddc-icon-skinny-arrow-left';

	const label = isNext
		? `Go to next page (${targetPage})`
		: `Go to previous page (${targetPage})`;

	const title = isDisabled
		? `${isNext ? 'Next' : 'Previous'} page not available`
		: `View ${isNext ? 'next' : 'previous'} page of matching results`;

	const className = `pagination-${isNext ? 'next' : 'previous'}${
		isDisabled ? ' disabled' : ''
	}`;

	return (
		<li className={className}>
			<a
				aria-label={label}
				aria-disabled={isDisabled}
				href={href}
				onClick={handleClick}
				title={title}
				className={isDisabled ? 'disabled' : ''}
			>
				<i className={iconClass} aria-hidden="true" />
			</a>
		</li>
	);
};

PaginationButton.propTypes = {
	direction: PropTypes.oneOf(['next', 'previous']).isRequired,
	paging: PropTypes.shape({
		pageStart: PropTypes.number.isRequired,
		pageSize: PropTypes.number.isRequired,
		totalCount: PropTypes.number.isRequired
	}).isRequired,
	onPageChange: PropTypes.func.isRequired
};

export default PaginationButton;
